"use client";

import React from "react";
import { ArrowUp, Instagram, Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-slate-800/20 animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/OurTeamPage" className="text-slate-400 hover:text-teal-400 transition-colors duration-300">
            Our Team
          </Link>
        </li>
        <li data-index={1}>
          <Link to="/HomePage" className="text-slate-400 hover:text-teal-400 transition-colors duration-300">
            Home
          </Link>
        </li>
        <li data-index={2}>
          <Link to="/ContactPage" className="text-slate-400 hover:text-teal-400 transition-colors duration-300">
            Contact
          </Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-slate-400 hover:text-teal-400 transition-colors duration-300">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  return <section data-section-id="166508" id="clinic-footer" className="dark bg-slate-950 text-slate-50 border-t-[0.5px] border-teal-500/20 pt-20 pb-10">
      <div className="container mx-auto px-6 md:px-8 lg:px-12 max-w-7xl">
        {}
        <div className="mb-16">
          <Link to="/HomePage">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612706/img/prestigecoat_logo_gold.png" alt="Freetown Family Clinic - Serving Freetown families with compassion" className="h-10 w-auto object-contain" />
          </Link>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-20">
          {}
          <div>
            <h3 className="text-lg font-serif font-semibold mb-6 text-teal-400 tracking-wide">
              Quick Links
            </h3>
            <MenuProvider menu_id="105">
              <FooterMenuLinks />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-lg font-serif font-semibold mb-6 text-teal-400 tracking-wide">
              Connect
            </h3>
            <div className="flex gap-5">
              <Link to="https://instagram.com" newTab className="text-slate-400 hover:text-teal-400 transition-all duration-300 border border-teal-500/20 rounded-full" aria-label="Instagram">
                <Instagram className="size-6 stroke-[1.5]" />
              </Link>
              <Link to="https://linkedin.com" newTab className="text-slate-400 hover:text-teal-400 transition-all duration-300 border border-teal-500/20 rounded-full" aria-label="LinkedIn">
                <Linkedin className="size-6 stroke-[1.5]" />
              </Link>
            </div>
          </div>

          {}
          <div>
            <h3 className="text-lg font-serif font-semibold mb-6 text-teal-400 tracking-wide">
              Contact
            </h3>
            <ul className="space-y-3">
              <li data-index={0}>
                <Link to="#" className="text-slate-400 hover:text-teal-400 transition-colors duration-300">
                  443-653-0459
                </Link>
              </li>
              <li data-index={1}>
                <Link to="#" className="text-slate-400 hover:text-teal-400 transition-colors duration-300">
                  info@freetownclinic.com
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 pt-8 border-t-[0.5px] border-teal-500/10">
          <p className="text-sm text-slate-500 font-sans tracking-wide">
            © {new Date().getFullYear()} Freetown Family Clinic. All rights reserved. • Privacy • Terms
          </p>
          
          <Button variant="outline" size="sm" onClick={scrollToTop} className="bg-transparent border-teal-500/30 text-slate-300 hover:bg-teal-500 hover:text-slate-950 hover:border-teal-500 transition-all duration-300 rounded-full px-6">
            Back to Top
            <ArrowUp className="size-4 ml-2" />
          </Button>
        </div>
      </div>
    </section>;
}